export async function runWithConcurrency<T>(
  tasks: Array<() => Promise<T>>,
  limit = 3
): Promise<T[]> {
  const results: T[] = [];
  let index = 0;

  async function worker() {
    while (index < tasks.length) {
      const currentIndex = index++;
      results[currentIndex] = await tasks[currentIndex]();
    }
  }

  await Promise.all(
    Array.from(
      {length: Math.min(limit, tasks.length)},
      () => worker()
    )
  );

  return results;
}